<template>
  <div id="container"> 
    <div class="box">

      <cont-top/>
      <cont-main/>
      <cont-bottom/>
      
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'
import ContTop from '@/components/component/cont_top'
import ContMain from '@/components/component/home/cont_main'
import ContBottom from '@/components/component/cont_bottom'


export default {
  name: 'Home',
  components: {
    ContTop ,
    ContMain ,
    ContBottom
  }
}
</script>

<style lang="stylus" scoped>
#container

.box 
  width: 100%;
 

</style>